import { useState } from "react"
import moment from "moment"
import {
  addProductInformationAnalytics,
  getAddAnotherProductAnalytics,
  modalNumberSupportLinkEventInfo,
  productInfoHandleSubmit,
} from "@/components/RegisterOfflineProduct/v1/RegisterOfflineHelper"
import Button from "@/components/core/Button/Button"
import ProductForm from "@/components/RegisterOfflineProduct/v1/ProductForm"
import plusIcon from "@/public/icons/plus.svg"
import htmlParser from "html-react-parser"
const ProductInformation = ({
  staticText = {},
  data: propData,
  status = "",
  statusCode = {},
  suggestions = [],
  getProductDetails = () => {},
  onNext = () => {},
  authorData = {},
  clearSuggestions = () => {},
  dealersDetail,
}) => {
  const emptyFormObj = {
    productDetails: { value: "", error: false, message: "" },
    serialNumber: { value: "", error: false, message: "" },
    dealerName: { value: "", error: false, message: "" },
    dateOfPurchase: { value: "", error: false, message: "" },
    customerImage: [],
    uploadedImage: [],
  }

  const [data, setData] = useState(propData ? propData : [emptyFormObj])
  const [currentForm, setCurrentForm] = useState("")

  const handleData = (index, formData) => {
    const newData = [...data]
    newData[index] = formData
    setData(newData)
  }

  const handleRemove = i => {
    const newData = [...data]
    newData.splice(i, 1)
    setData(newData)
  }

  const handleSubmit = () => {
    const { newData, valid, errorMessage } = productInfoHandleSubmit(
      data,
      staticText
    )
    setData(newData)
    getProductDetails(newData)
    if (valid) {
      addProductInformationAnalytics("cmp:click", newData, "success")
      onNext()
    } else
      addProductInformationAnalytics(
        "cmp:click",
        newData,
        "failure",
        errorMessage
      )
  }

  const handleAddAnotherProd = e => {
    setData([...data, emptyFormObj])
    window.preActiveElement = e.target
  }

  const checkDisabled = data => {
    const isDisabled = data?.some(
      list =>
        list.productDetails.error ||
        !list.dateOfPurchase.value ||
        list.productImages.length === 0
    )
    return isDisabled
  }

  return (
    <div className="product-information">
      {status === statusCode.COMPLETE ? (
        <div className="product-info-result">
          <ul>
            {data.map((item, i) => {
              return (
                <li key={i}>
                  <div className="product-data" role="presentation">
                    <span aria-hidden="true">{item.productDetails.value}</span>
                    <span aria-hidden="true">{item.serialNumber.value}</span>
                    <span aria-hidden="true">{item.dealerName.value}</span>
                    <span aria-hidden="true">
                      {moment(item.dateOfPurchase.value)?.format("DD/MM/YYYY")}
                    </span>
                  </div>
                </li>
              )
            })}
          </ul>
        </div>
      ) : (
        <div className="product-information-container">
          <p className="product-model-url">
            {authorData?.linkText && (
              <a
                href={authorData?.link}
                className="gbh-data-layer"
                data-gbh-data-layer={modalNumberSupportLinkEventInfo}
                target={authorData?.linkToNewTab ? "_blank" : "_blank"}
                rel="noreferrer"
              >
                {authorData?.linkText}
              </a>
            )}
          </p>
          <p className="product-info-description">
            {authorData.productInfoDescription
              ? htmlParser(authorData.productInfoDescription)
              : staticText.productInfoDescription}
          </p>
          {data &&
            data.map((item, i) => (
              <ProductForm
                staticText={staticText}
                key={i}
                id={i}
                data={data[i]}
                currentForm={currentForm}
                suggestions={suggestions}
                setCurrentForm={setCurrentForm}
                removeForm={() => handleRemove(i)}
                handleData={data => handleData(i, data)}
                clearSuggestions={clearSuggestions}
                dealersDetail={dealersDetail}
              />
            ))}
          <div className="add-another-product">
            <button
              className="add-another-product-button gbh-data-layer"
              data-gbh-data-layer={getAddAnotherProductAnalytics()}
              onClick={handleAddAnotherProd}
            >
              <span className="plus-icon">
                <img src={plusIcon?.src} alt="" />{" "}
              </span>{" "}
              {staticText.addAnotherProductToRegister}
            </button>
          </div>

          <div className="button-container">
            <Button
              tag="button"
              ariaLabel={staticText.ariaLabel.next}
              type="black"
              label={staticText.next}
              onClick={() => handleSubmit()}
              disabled={checkDisabled(data)}
              testid={`${staticText.next}-product-info`}
              useDefaultClass
            />
          </div>
        </div>
      )}
    </div>
  )
}

export default ProductInformation
